export default __webpack_public_path__ + "media/images/react_icons/checkout_calendar_icon-139e27db719298a41fdd37af4c55a7e8.svg";